// based off React's ExecutionEnvironment canUseDOM
export default () => !!(typeof window !== 'undefined' && window.document);
